import { GeneralSettingParameter } from "models/generalSetting/generalSetting";
import { getGeneralSettingValue } from "./general-settings";

export const loadCompositionBrewerySideActive = () => getGeneralSettingValue(GeneralSettingParameter.LoadCompositionNewFlow);
